<template>
    <div>
        <div class="modal fade" id="integrationsModal" tabindex="-1" role="dialog" aria-labelledby="integrationsModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="integrationsModalLabel">Integration</h5>
                        <button type="button" class="btn-close" @click="noHandler" aria-label="Close">

                        </button>
                    </div>
                    <div class="modal-body">

                        <h4>{{integration.name}}</h4>

                        <form>
                            <div class="row mb-3">
                                <label for="nameInput" class="col-sm-3 col-form-label">API Key</label>
                                <div class="col-sm-9">
                                    <input id="nameInput" type="text" class="form-control" placeholder="API Key"
                                           v-model="integration.metadata.api_key">
                                </div>
                            </div>

                        </form>


                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="yesHandler" >Ok</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import IntegrationsService from "../services/IntegrationsService";

    export default {
        name: 'IntegrationsModal',
        props: {
            yesEvent: Function,
            integration: Object
        },
        data () {
            return {
                model: webase.model,
                service: new IntegrationsService(),
                currentModal: null,
                modalElement: null,
            }
        },
        mounted() {
            this.modalElement = document.getElementById('integrationsModal')
            this.currentModal = new bootstrap.Modal(this.modalElement)

            this.modalElement.addEventListener('hidden.bs.modal', this.onModalHidden)

            this.currentModal.show()
        },
        beforeUnmount() {
            this.modalElement.removeEventListener('hidden.bs.modal', this.onModalHidden)
        },
        methods: {
            onModalHidden() {
                this.$emit('noEvent')
            },
            noHandler(e) {
                this.currentModal.hide()
            },
            yesHandler(e) {


                if (this.integration.id === null) {
                    this.create()
                } else {
                    this.update()
                }

                // call the parent's "yesEvent"
                if(this.yesEvent) {
                    this.yesEvent()
                }
                // hide the modal
                this.noHandler()
            },
            create() {
                let request = {
                    integration: this.integration
                }

                this.service.create(request).then((response) => {
                    console.log('integration created')
                    this.model.app.integrations.push(response)
                }).catch((message) => {
                    console.log('error creating integration')
                    console.log(message)
                })
            },
            update() {
                let request = {
                    integration: this.integration
                }

                this.service.update(this.integration.id, request).then((response) => {
                    console.log('integration updated')
                }).catch((message) => {
                    console.log('error updating integration')
                    console.log(message)
                })
            }
        }
    }
</script>
